import React from 'react';
import { Link } from 'react-router-dom'; // Assuming you use react-router-dom

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white mt-auto py-6 sm:py-8 shadow-inner" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* --- Top Section: Links --- */}
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center border-b border-gray-700 pb-4 mb-4">
          <p className="text-xl font-bold mb-3 sm:mb-0 text-teal-400">
            مرحبا بك في منصة طفلي المبدع 🌟
          </p>

          <nav className="flex space-x-6 space-x-reverse text-lg font-medium">
            <Link
              to="/privacy"
              className="hover:text-teal-400 transition-colors duration-300 transform hover:scale-105"
            >
              سياسة الخصوصية
            </Link>
            <Link
              to="/rules"
              className="hover:text-teal-400 transition-colors duration-300 transform hover:scale-105"
            >
              قواعد الاستخدام
            </Link>
          </nav>
        </div>
        
        {/* --- Bottom Section: Copyright --- */}
        <div className="text-center text-sm text-gray-400">
          &copy; {currentYear} جميع الحقوق محفوظة.
        </div>
      </div>
    </footer>
  );
};

export default Footer;